/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import ClientsTable from './components/ClientsTable';

const Clients = (props) => {
  const { history, location } = props;
  return (
    <div className="clients container">
      <Card>
        <CardBody>
          {/* <h2><strong>Clientes</strong></h2> */}
          <ClientsTable history={history} location={location} />
        </CardBody>
      </Card>
    </div>
  );
};

Clients.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};

export default Clients;
